
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/architects-for-azaz",
      function () {
        return require("private-next-pages/architects-for-azaz/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/architects-for-azaz"])
      });
    }
  